
	import { Component, Mixins, Prop } from "vue-property-decorator";
	import { namespace, Mutation } from "vuex-class";
    import { ActionPlan, ActionTrigger, NewActionTrigger, TaskCategory, TaskLibrary, TaskType } from "@/store/tasks/types";
    import { TreeView } from "@/types/treeView";
	import ActionList from "@/components/actions/ActionList.vue";
	import { ActionsList } from "@/types/ActionList";
	import ActionsMixin from "@/mixins/ActionsMixin";
	import VuePerfectScrollbar from "vue-perfect-scrollbar";
	import { validationMixin } from "vuelidate";
	import { required } from "vuelidate/lib/validators";

    // API
    import api from "@/services/api.service";

    // Namespaces
    const Tasks = namespace("tasks");

	@Component({
        components: {
            "vue-perfect-scrollbar": VuePerfectScrollbar,
            "action-list": ActionList
        },
        mixins: [validationMixin],
        validations: {
            checkedActionList: {
                required
            }
        }
    })
	export default class AddSubAction extends Mixins(ActionsMixin) {        
        @Tasks.Action fetchTaskTriggers: () => Promise<void>;
        @Tasks.Action fetchActionPlans: () => Promise<void>;
        @Tasks.Action fetchActionLibrary: () => Promise<void>;

        @Tasks.State(state => state.TaskCategories) taskCategories: TaskCategory[];
        @Tasks.State(state => state.TaskLibrary) taskLibrary: TaskLibrary[];
        @Tasks.State(state => state.TaskTypes) taskTypes: TaskType[];
        @Tasks.State taskTriggers: ActionTrigger[];

        @Prop() selectedAction: TaskLibrary;

        @Prop() 
        private showSubActionModal: boolean;

        @Prop() selectedActionPlan: ActionPlan;

        @Prop({ type: Array, default: () => ([]) }) actionPlan: TreeView[];

        private checkedActionList: ActionsList[] = [];
        private isBusyLoading: boolean = false;

        /**
         * @summary Mounted Hook
         * @returns Promise<void>
         */
        public async mounted(): Promise<void> {
            // Mount method.
            this.isBusyLoading = true;
            await this.fetchActionPlans();
            await this.fetchTaskTriggers();
            this.isBusyLoading = false;
        }

        /**
         * @summary filter the current (parent) out of the list of actions as can't be a child of itself
         * @returns a list of task librarys
         */
        private get filteredActionLibrary(): TaskLibrary[] {
            return this.taskLibrary.filter((actionLib: TaskLibrary) => this.selectedAction.taskID != actionLib.taskID);
        }

        /**
         * @summary Method to save child action to the selected action
         * @returns Promise<void>
         */
        private async saveChildToAction(): Promise<void> {
            let payload: NewActionTrigger[] = [];

            this.checkedActionList.forEach((action: ActionsList) => {
                const taskTrigger = this.getTaskTriggerByActionId(this.selectedAction.taskID);
                const taskLibrary = this.taskLibrary.find(taskLib => taskLib.taskID == action.actionId);
                if (!taskLibrary) return;
                taskLibrary.taskData = null;
                payload.push({
                    required: taskTrigger ? taskTrigger.required : false,
                    resultCondition: action.condition ?? null,
                    taskID: this.selectedAction.taskID,
                    triggerTaskID: taskLibrary.taskID,
                    trigger: taskLibrary
                });
            });

            const deleteExistingTriggers: boolean = false;
			await api.triggeredTasksSave(
				this.selectedAction.taskID,
                payload, 
                deleteExistingTriggers
            );
 
            // NOTE Future development should remove this 
            // and append result to the array,
            // not refetch the full list - old actin setup TechDebt
            await this.fetchActionPlans();
            await this.fetchTaskTriggers();
            await this.fetchActionLibrary();

            this.$emit('close-sub-action');
        }
        /**
         * @summary Closes the current modal
         */
        private closeModal(): void {
            this.$emit('close-sub-action');
        }
	}
